const STREAM_API_KEY = 'a2ce1554564a186034715195a44a4e26';
const STREAM_BASE_URL = 'https://stream.tip24.bet';


// ── Types ────────────────────────────────────────────────────────────────────

export interface LivestreamInfo {
  match_id: string;
  start_time: string;
  sport: string;
  tournament: string;
  home: string;
  away: string;
  watch_url: string;
}

// ── Helpers ──────────────────────────────────────────────────────────────────

function apiHeaders(accept: string): Record<string, string> {
  return { 'x-api-key': STREAM_API_KEY, Accept: accept };
}

// ── 4.1  GET /api/livestreams ─────────────────────────────────────────────────
// Returns all matches that currently have an active stream, including watch_url.

export async function getActiveLivestreams(): Promise<LivestreamInfo[]> {
  try {
    const response = await fetch(
      `${STREAM_BASE_URL}/api/livestreams`,
      { method: 'GET', headers: apiHeaders('application/json') },
    );
    if (response.ok) {
      const data = await response.json();
      if (data && Array.isArray(data.livestreams)) {
        return data.livestreams as LivestreamInfo[];
      }
    }
    return [];
  } catch (error) {
    console.error('Error fetching active streams:', error);
    return [];
  }
}

// ── 4.2  GET /api/livestreams/{match_id} ──────────────────────────────────────
// Returns full details (including watch_url) for a specific match.
// Returns null if no stream is available for that match.

export async function getMatchStreamInfo(matchId: string): Promise<LivestreamInfo | null> {
  try {
    const response = await fetch(
      `${STREAM_BASE_URL}/api/livestreams/${encodeURIComponent(matchId)}`,
      { method: 'GET', headers: apiHeaders('application/json') },
    );
    if (response.status === 200) {
      return (await response.json()) as LivestreamInfo;
    }
    return null;
  } catch (error) {
    console.error('Error fetching stream info:', error);
    return null;
  }
}

// ── 4.3  GET /launch/{match_id} ───────────────────────────────────────────────
// Convenience endpoint — returns only the watch_url as plain text.
// Preferred for on-demand checks where you only need the URL.

export async function getMatchStreamUrl(matchId: string): Promise<string | null> {
  try {
    const response = await fetch(
      `${STREAM_BASE_URL}/launch/${encodeURIComponent(matchId)}`,
      { method: 'GET', headers: apiHeaders('text/plain') },
    );
    if (response.status === 200) {
      return (await response.text()).trim();
    }
    // 404 → no stream; 401/500 → errors
    return null;
  } catch (error) {
    console.error('Error fetching stream URL:', error);
    return null;
  }
}
